"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Dimensions = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Dimensions"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
var _Tooltip2 = _interopRequireDefault(require("./Tooltip.native"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Tooltip = !_Dimensions.default.get('screen').width <= 340 ? _Tooltip2.default : _Tooltip.default;
var _default = exports.default = Tooltip;